import * as React from 'react';

import PlanSelection140 from './PlanSelection140';

export const planSelection140 = () => <PlanSelection140 />;

export default {
    title: 'Illustration/PlanSelection140',
    component: PlanSelection140,
    parameters: {
        notes: "`import PlanSelection140 from 'box-ui-elements/es/illustration/PlanSelection140';`",
    },
};
